import { Box, Typography } from "@mui/material";
import React from "react";
import MapLinearBar from "../MapLinearBar";
import "./index.scss";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

export default function States({ location }) {
  // console.log(data, "::::::State data");
  // console.log(location, "::Statelocation::");
  const firstFiveData = location.slice(0, 5);
  return (
    <Box>
      <div className="skills-box">
        {firstFiveData?.map((data, index) => (
          <div className="bar bar_one" key={index}>
            <div className="info">
              <span>{data.country}</span>
            </div>
            <div className="level">
              <MapLinearBar value={`${data.value2}%`} />
              <div className="info new">
                <span>{data.value2}%</span>
              </div>
            </div>
          </div>
        ))}
      </div>
      {/* <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "8px",
          position: "absolute",
          bottom: "0",
          width: "100%",
          borderTop: "1px solid #707070 ",
          // padding: padd ? "10px 15px 8px 15px" : "",
        }}
      >
        <Typography style={{ fontSize: "14px", color: "#FFEE20" }}>
          Show more
        </Typography>
        <Typography style={{ display: "flex", alignItems: "center" }}>
          <ArrowForwardIosIcon sx={{ fontSize: "small", color: "#FFEE20" }} />
        </Typography>
      </Box> */}
    </Box>
  );
}
